import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Konsole from "../../utils/konsole/Konsole";
import StepTitle from "../RightSideBar/StepTitle/StepTitle";
import selectOptionData from "../../utils/CustomizedCalculation/SelectOptionData";
import { SETCHANGE_SELECTMEALITEM1, SETCHANGE_SELECTMEALITEM2, SETMEALCUSTOMIZEDATA, SETMEALDATA } from "../../redux/features/MealData";
import StoreDescription from "../Store/Store-Description";
import getSubData from "../../utils/CustomizedCalculation/GetSubData";
import { ValidateOptionCategory } from "../../utils/helper";
import GetStepOptionId from "../../utils/CustomizedCalculation/GetStepOptionId";
import { ClearCustomizeMealItem } from "../../utils/Meal";
// MealCustomizeOption
import MealCustomizeOption from "./MealCustomizeOption";
import SelectAddOnData from "../../utils/CustomizedCalculation/SelectAddOnData";
import AddOnData from "../RightSideBar/AddOnData/AddOnData";
import { ReturnPrice } from "../../utils/orderUtils/OrderUtils";
import { useTranslation } from "react-i18next";
import GlobalButton from "../Buttons/btn2/GlobalButton";
const MealCustomizeItem = () => {
    const reduxData = useSelector((state: any) => state);
    const { mealData: { mealData, mealCustomizeData, selectMealItem1, selectMealItemdata2 } } = reduxData;
    const disPatch = useDispatch()
    const {t} = useTranslation();

    // @@ define state 
    const [stepOptionId, setStepOptionId] = useState<any>([]);
    const [categoryId, setCategoryId] = useState<any>([]);
    const [selectAddOn, setSelectedAddOn] = useState<any>([]);

    const [error, setError] = useState(false);

    //Konsole.log('selectMealItemdata2selectMealItemdata2', mealCustomizeData, selectMealItemdata2)

    useEffect(() => {
        // @@ category andb optioon of selected Edit item
        if (selectMealItemdata2?.selectedMealItem && selectMealItemdata2?.selectedMealItem?.length > 0 && selectMealItemdata2?.selectedMealItem[0]?.map_item_meal_id == mealCustomizeData?.map_item_meal_id) {
            setStepOptionId(selectMealItemdata2?.selectedMealItem?.[0]?.selectedoptions);
            setCategoryId(selectMealItemdata2?.selectedMealItem?.[0]?.selectedCategory);
            setSelectedAddOn(selectMealItemdata2?.selectedMealItem?.[0]?.selected_addOn);
        } else {
            setStepOptionId([]);
            setCategoryId([])
        }
    }, [selectMealItemdata2])

    // @@ return meal Details from customize items
    const meal = useMemo(() => {
        return mealData?.meal
    }, [])

    // @@ item_step form selected meal
    const itemStep = useMemo(() => {
        return mealCustomizeData?.item_step;
    }, [mealCustomizeData, mealData, selectMealItemdata2, stepOptionId]);

    // @@ item_subCategory form selected meal
    const itemSubCategory = useMemo(() => {
        return mealCustomizeData?.step_sub_category_data
    }, [mealCustomizeData, mealData, selectMealItemdata2, categoryId])

    // @@ item_subCategory form selected meal
    const itemAddOnAllData = useMemo(() => {
        return mealCustomizeData?.addon_data
    }, [mealCustomizeData, mealData, selectMealItemdata2, selectAddOn])


    //Konsole.log('selectMealItem1', selectMealItemdata2)
    // @@ back with clear redux
    const handleBack = () => {
        ClearCustomizeMealItem(disPatch)
    }


    // @@ ADD to meal select item
    const handleAddToMeel = () => {
        const item = structuredClone(mealCustomizeData);
        // @@ validate category and options
        const res = ValidateOptionCategory(item, stepOptionId, categoryId);
        // console.log("res", res)
        //Konsole.log("res//Konsole", res);
        if (!res) {
            setError(true);
            scrollError();
            return;
        }

        // @@ Update meal info in store redux
        let allMealInfo = structuredClone(mealData) // selected complete data
        let allMealData = structuredClone(meal) // meals from selected item
        let selectedMealItem = structuredClone(selectMealItem1)
        let mealDataOfClickedItem = selectMealItemdata2;
        mealDataOfClickedItem['clicked_map_item_meal_id'] = selectMealItem1?.map_item_meal_id // for check

        // mealDataOfClickedItem['selectedMealItem']=[..selectMealItem1]

        // @@ manage seprate selectedItem
        selectedMealItem['selectedCategory'] = categoryId;
        selectedMealItem["selected_addOn"] = selectAddOn || [];
        selectedMealItem['selectedoptions'] = GetStepOptionId({ selectedVariation: mealDataOfClickedItem?.item_variation, stepOptionId, });
        mealDataOfClickedItem['selectedMealItem'] = [selectedMealItem] // for radio push data

        // @@ manage inside item selectedItem
        // let findIndexOfitem = mealDataOfClickedItem?.meal_item_data?.findIndex((i: any) => i.map_item_meal_id == selectMealItem1?.map_item_meal_id);
        // mealDataOfClickedItem['meal_item_data'][findIndexOfitem]['selectedCategory'] = categoryId;
        // mealDataOfClickedItem['meal_item_data'][findIndexOfitem]['selectedoptions'] = GetStepOptionId({ selectedVariation: mealDataOfClickedItem?.item_variation, stepOptionId, })
        // mealDataOfClickedItem["selectedCategory"] = categoryId;
        // mealDataOfClickedItem["selectedoptions"] = GetStepOptionId({ selectedVariation: mealDataOfClickedItem?.item_variation, stepOptionId, })
        //Konsole.log('mealDataOfClickedItem', mealDataOfClickedItem);

        // return;

        // @@ update selected meal item
        if (allMealData?.length > 0) {
            let findIndex = allMealData?.findIndex((i: any) => i?.meal_id == mealDataOfClickedItem?.meal_id)
            if (findIndex) {
                allMealData.splice(findIndex, 1, mealDataOfClickedItem)
            }
            allMealInfo['meal'] = allMealData;
            //Konsole.log('allMealDataasdf', allMealData, allMealInfo)
            disPatch(SETMEALDATA(allMealInfo));
            ClearCustomizeMealItem(disPatch)
        }

    }



    // Function to scroll to an element by its ID
    const scrollError = () => {
        setTimeout(() => {
            const element = document.getElementById("errorScroll");
            //Konsole.log("elementelement", element);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest", });
            }
        }, 1);
    };

    //Konsole.log('mealCustomizeData', mealCustomizeData);
    //Konsole.log('itemSubCategory', itemSubCategory)
    //Konsole.log('stepOptionId', stepOptionId, itemStep);
    // console.log("itemAddOnAllData", selectAddOn)
    return (
        <>
            <div className="flex justify-between items-center sticky top-0 bg-white md:px-8 px-3 py-3 z-50 pointer-events-auto">
                {mealData?.name && (
                    <h4 className={`md:text-[1.5rem] text-xl font-normal font-splekta`}  >

                        {/* @@ Back button */}
                        <i onClick={() => handleBack()} className="fa fa-arrow-left cursor-pointer" style={{ fontSize: '1.2rem' }} aria-hidden="true"></i>  {mealData?.name}
                    </h4>
                )}
            </div>

            <div className="md:px-8 px-3 pb-20 scroll-hidden pointer-events-auto touch-auto">

                <div className="variationSection mb-2">

                    {/* @@ Display  step data */}
                    {itemStep?.map((stepList: any, itIndex: number) => {
                        const errorVal = error && stepList?.required == 1 && stepOptionId?.filter((obj: any) => { return obj.step_id === stepList?.item_step_id; })?.length == 0;
                        const id = errorVal ? "errorScroll" : "noScroll";

                        return <div id={id} className="variationSection mb-2" key={stepList.item_step_id}>
                            {stepList?.option?.length > 0 ?
                                <StepTitle
                                    key={stepList.item_step_id}
                                    stepTitle={stepList?.title}
                                    required={stepList?.required == 1}
                                    err={errorVal}
                                    success={stepList?.required == 1 && stepOptionId?.filter((obj: any) => { return obj.step_id === stepList?.item_step_id; })?.length}
                                />
                                : null}

                            <span className="textMd text-[#4B4B4B]"> {t("Home.choose")} {stepList.max_count} </span>

                            {stepList?.option?.map((optionData: any, iOptionIndex: number) => {

                                let isChecked = stepOptionId?.find((i: any) => i.item_step_option_id == optionData?.item_step_option_id) ? true : false
                                // //Konsole.log('isCheckedisChecked', isChecked, stepOptionId)


                                return <div key={optionData?.item_step_option_id + iOptionIndex}>

                                    <MealCustomizeOption

                                        defaultChecked={isChecked}
                                        id={optionData?.item_step_option_id}
                                        price={ReturnPrice(optionData) || 0}
                                        itemName={optionData?.title}
                                        disabled={
                                            stepOptionId.filter((obj: any) => {
                                                return obj.step_id === stepList.item_step_id;
                                            })?.length == stepList.max_count &&
                                            stepOptionId.find((obj: any) => {
                                                return (obj.item_step_option_id === optionData.item_step_option_id);
                                            }) == undefined
                                        }
                                        onchange={(e: any) => {
                                            setError(false);
                                            selectOptionData({ e, optionData, stepList, stepOptionId, setStepOptionId, });
                                        }}
                                    />

                                </div>
                            })}
                        </div>
                    })}


                    {/* @@ Step step_sub_category data  */}

                    {itemSubCategory?.map((stepList: any, stepListIndex: number) => {
                        const errorVal = error && stepList?.required == 1 && categoryId?.filter((obj: any) => { return obj.side_id === stepList?.item_step_id; })?.length == 0;
                        const id = errorVal ? "errorScroll" : "noScroll";

                        return <React.Fragment key={stepListIndex}>
                            {stepList ?
                                <div id={id} className="variationSection mb-2" key={stepList.item_step_id}>

                                    {stepList?.map_item_side?.length > 0 && (
                                        <StepTitle
                                            key={stepList.item_step_id}
                                            stepTitle={stepList?.title}
                                            required={stepList?.required == 1}
                                            err={error && stepList?.required == 1 &&
                                                categoryId?.filter((obj: any) => {
                                                    return obj.side_id === stepList?.item_step_id;
                                                })?.length == 0
                                            }
                                            success={
                                                stepList?.required == 1 &&
                                                categoryId?.filter((obj: any) => {
                                                    return obj.side_id === stepList?.item_step_id;
                                                })?.length
                                            }
                                        />

                                    )}
                                    <span className="textMd text-[#4B4B4B]"> {t("Home.choose")} {stepList.max_count}</span>
                                    {stepList?.map_item_side?.map((optionData: any) => {
                                        let isChecked = categoryId?.find((i: any) => i?.mapNewItem?.item_id == optionData?.mapNewItem?.item_id) ? true : false
                                        return (
                                            <>
                                                {optionData ? (
                                                    <div key={optionData?.item_id}>
                                                        <MealCustomizeOption
                                                            defaultChecked={isChecked}
                                                            price={ReturnPrice(optionData?.mapNewItem) || 0}

                                                            id={optionData?.item_id}
                                                            itemName={optionData?.mapNewItem?.name}
                                                            disabled={
                                                                categoryId.filter((obj: any) => {
                                                                    return (obj.side_id === stepList?.item_step_id);
                                                                })?.length == stepList.max_count &&
                                                                categoryId.find((obj: any) => {
                                                                    return obj.item_id === optionData.item_id;
                                                                }) == undefined
                                                            }
                                                            onchange={(e: any) =>
                                                                getSubData({ e, optionData, stepList, categoryId, setCategoryId, customizedData: '', })
                                                            }
                                                        />
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </>
                                        );
                                    })}
                                </div>
                                : null}
                        </React.Fragment>
                    })}

                    {/* @@@ ADD ON DATA  */}
                    <AddOnData
                        key={selectAddOn}
                        selectAddOn={selectAddOn}
                        setSelectedAddOn={setSelectedAddOn}
                        addon_data={itemAddOnAllData}
                        refrencePage={'MealCustomizeData'}
                    />

                </div>

            </div>

            {/* @@ handle add to meel button */}
            <div className="fixed bottom-0 w-full bg-white touch-auto pointer-events-auto md:px-8 px-3 py-4 border-t border-[#ECECEC]">
                <div className=" flex justify-end ">
                    {/* <button onClick={() => handleAddToMeel()} className=" lg:w-1/2 inline-flex justify-center md:gap-14 btn-secondary !px-4 py-4">
                        <div className="flex gap-3">
                            {t("MyOrders.addToMeal")}
                        </div>
                    </button> */}

                    <GlobalButton 
                    onClick={() => handleAddToMeel()}
                    label=  {t("MyOrders.addToMeal")}
                    className="md:w-1/3 lg:w-1/3 xl:w-1/3"
                    />
                </div>

            </div>
        </>
    )
}

export default MealCustomizeItem